var exports = {
  "j": "xfd349460--7e74d2--road",
  "x": "xfd349460--7e74d2--road-icon",
};

module.exports = exports;
